export default __webpack_public_path__ + "static/hiring_img-fa1cdbe67aadfbee94c9030180818172.webp";